import { useFormik } from 'formik';
import { useState } from 'react';
import Input from 'components/common/Input';
import { BSON } from 'realm-web';
import * as Yup from 'yup';

import { useItemModifierMutations } from 'graphql/useItemExtraMutations';
import { useTranslation } from 'react-i18next';
import FormHeader from 'components/common/FormHeader';
import Modifier from './ItemsModifier/Modifier';
import s from './styles';

function AddModifier({
  closeModal,
  editItem = {},
  onUpdateSuccess,
  onAddSuccess,
  setErrorMessage,
}) {
  const { t } = useTranslation();
  const [dbLoading, setDbLoading] = useState(false);
  const loading = dbLoading;

  const [modifiers, setmodifiers] = useState(
    editItem || {
      _id: new BSON.ObjectId(),
      name: '',
      modifiers: [
        {
          _id: new BSON.ObjectId(),
          isQuantifiable: false,
          name: '',
          price: null,
          toAdd: false,
          toRemove: false,
        },
      ],
      updateDatetime: new Date(),
      creationDatetime: new Date(),
    }
  );

  const { addItemModifier, updateItemModifier } = useItemModifierMutations();

  const {
    handleSubmit,
    handleChange,
    values,
    setFieldValue,
    errors,
    isValid,
    dirty,
  } = useFormik({
    initialValues: modifiers,
    onSubmit: async (values) => {
      let newValues;
      if (editItem === null) {
        newValues = {
          ...values,
          updateDatetime: new Date(),
          creationDatetime: new Date(),
        };
      } else {
        newValues = {
          ...values,
          updateDatetime: new Date(),
        };
      }
      try {
        setDbLoading(true);
        if (editItem === null) {
          await addItemModifier(newValues);

          await setDbLoading(false);

          onAddSuccess();
        } else {
          await updateItemModifier(editItem, { ...newValues });

          await setDbLoading(false);

          onUpdateSuccess();
        }
        closeModal();
      } catch (error) {
        await setDbLoading(false);
        setErrorMessage({ error });
      }
    },

    validationSchema: Yup.object().shape({
      name: Yup.string().required(),
      modifiers: Yup.array().of(
        Yup.object().shape({
          name: Yup.string().required(),
        })
      ),
    }),
  });

  // add new modifier
  const addModifier = () => {
    setmodifiers({
      ...modifiers,
      modifiers: [
        ...modifiers.modifiers,
        {
          _id: new BSON.ObjectId(),
          isQuantifiable: false,
          name: '',
          price: null,
          toAdd: false,
          toRemove: false,
        },
      ],
    });
    values.modifiers = [
      ...values.modifiers,
      {
        _id: new BSON.ObjectId(),
        isQuantifiable: false,
        name: '',
        price: null,
        toAdd: false,
        toRemove: false,
      },
    ];
  };

  const handleRemoveItem = (index) => {
    setmodifiers({
      ...modifiers,
      modifiers: modifiers.modifiers.filter((item, i) => i !== index),
    });
    values.modifiers = values.modifiers.filter((item, i) => i !== index);
  };

  return (
    <>
      <FormHeader
        addTitle={t('components.InventoryModifiers.AddItem.createModifier')}
        updateTitle={t('components.InventoryModifiers.AddItem.editModifier')}
        closeModal={closeModal}
        updating={editItem && Object.keys(editItem).length > 0}
        onSave={handleSubmit}
        saving={loading}
        enabled={isValid && dirty}
      />

      <s.BodyContainer>
        <s.Title>
          {t('containers.InventoryModifiers.AddModifier.newModifier')}
        </s.Title>
        <s.Line style={{ marginTop: '18px', marginBottom: '40px' }} />
        <Input
          placeholder={t(
            'containers.InventoryModifiers.AddModifier.enterModifierName'
          )}
          style={{ width: '65%' }}
          name="name"
          value={values.name}
          onChange={handleChange}
        />
        {errors.name && (
          <s.messageAlert style={{ marginBottom: '-32px' }}>
            {t(
              'containers.InventoryModifiers.AddModifier.modifierNameRequired'
            )}
          </s.messageAlert>
        )}

        <s.SectionTitle>
          <s.Title style={{ marginTop: '67px' }}>
            {t('containers.InventoryModifiers.AddModifier.modifierComponents')}
          </s.Title>
          <s.addComponent onClick={addModifier} style={{ marginTop: '67px' }}>
            +{t('containers.InventoryModifiers.AddModifier.addComponent')}
          </s.addComponent>
        </s.SectionTitle>
        <s.Line style={{ marginTop: '18px', marginBottom: '10px' }} />

        {modifiers?.modifiers?.map((item, index) => (
          <Modifier
            key={index}
            item={item}
            index={index}
            setFieldValue={setFieldValue}
            values={values}
            errors={errors}
            handleRemoveItem={handleRemoveItem}
          />
        ))}
      </s.BodyContainer>
    </>
  );
}

export default AddModifier;
